module.exports = __webpack_public_path__ + "img/facebook-icon.02b848c6.svg";